import * as React from 'react';

import { pure } from 'recompose';

type Props = {
  partner?: {
    name?: string;
  };
  // Original propType: object
  htmlAttributes?: $TSFixMe;
};

const PartnerName = ({ partner, htmlAttributes }: Props) => {
  if (!partner || !partner.name) {
    return null;
  }
  return <span {...htmlAttributes}>{partner.name}</span>;
};

export default pure(PartnerName);
